import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from 'react-router';

const Styles = {
  menu: {
    flexWrap: 'wrap',
  },
  item: {
    marginBottom: '5px',
  },
};

const content = (s, errors) => {
  if (errors.has(s.id.toString())) {
    return (
      <Link
        key={s.id}
        to={`sites/${s.id}`}
        activeClassName="active"
        className="item teal"
        style={Styles.item}
      >
        <i className="red circle remove icon" />
        {s.name}
      </Link>
    );
  } else {
    return (
      <Link
        key={s.id}
        to={`sites/${s.id}`}
        activeClassName="active"
        className="item teal"
        style={Styles.item}
      >
        {s.name}
      </Link>
    );
  }
};

const SiteTabs = ({ sites, errors }) => {
  if (sites.length) {
    return (
      <div className="ui secondary menu" style={Styles.menu}>
        {sites.map(s => content(s, errors))}
      </div>
    );
  }

  return null;
};

SiteTabs.propTypes = {
  sites: PropTypes.array.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
};

export default SiteTabs;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/SiteTabs.js